// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3CWAc","notes":"Notes_notes__2puRl"};